<template>
  <header class="header">
    <div class="container">
      <router-link class="logo" to="/home"
        ><img src="@/assets/logo.png" alt=""
      /></router-link>

      <button
        class="hamburger"
        @click="toggleMobileMenu"
        :class="{ open: mobileMenuOpen }"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav class="nav" :class="{ 'mobile-open': mobileMenuOpen }">
        <div
          class="nav-item dropdown"
          @click="handleDropdownClick"
          @mouseenter="onDropdownEnter"
          @mouseleave="onDropdownLeave"
        >
          <span class="nav-link" :class="{ active: isProductActive }">{{
            $t("header2_product")
          }}</span>
          <div class="dropdown-menu" v-show="showDropdown">
            <router-link to="/particle">{{ $t("header1_particle_detector") }}</router-link>
            <router-link to="/trans-pet">{{ $t("header1_pet") }}</router-link>
            <router-link to="/radsys2">{{ $t("header1_radiation_detection") }}</router-link>
          </div>
        </div>
        <router-link
          to="/Plug-n-Image"
          :class="{ active: $route.path === '/Plug-n-Image' }"
          >{{ $t("header2_solution") }}</router-link
        >
        <router-link to="/ip" :class="{ active: $route.path === '/ip' }">{{
          $t("header2_ip")
        }}</router-link>
        <router-link
          to="/about"
          :class="{ active: $route.path === '/about' }"
          >{{ $t("header2_about") }}</router-link
        >
        <router-link
          to="/happening"
          :class="{ active: $route.path === '/happening' }"
          >{{ $t("header2_happening") }}</router-link
        >
        <a href="#" class="lang" @click.prevent="toggleLanguage">{{
          currentLang
        }}</a>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      currentLang: "EN",
      showDropdown: false,
      mobileMenuOpen: false,
      isMobile: false,
    };
  },
  computed: {
    isProductActive() {
      return ["/trans-pet", "/radsys2", "/particle"].includes(this.$route.path);
    },
  },
  watch: {
    $route() {
      this.mobileMenuOpen = false;
      this.showDropdown = false;
    },
  },
  mounted() {
    this.currentLang = this.$i18n.locale === "zh" ? "EN" : "中文";
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/home" });
    },
    toggleLanguage() {
      const current = this.$i18n.locale;
      const next = current === "zh" ? "en" : "zh";
      this.$emit("before-language-change", next);
      this.$i18n.locale = next;
      localStorage.setItem("language", next);
      this.currentLang = next === "zh" ? "EN" : "中文";
      this.$emit("language-changed", next);
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      if (!this.mobileMenuOpen) {
        this.showDropdown = false;
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) {
        this.mobileMenuOpen = false;
      }
    },
    handleDropdownClick() {
      if (this.isMobile) {
        this.showDropdown = !this.showDropdown;
      }
    },
    onDropdownEnter() {
      if (!this.isMobile) {
        this.showDropdown = true;
      }
    },
    onDropdownLeave() {
      if (!this.isMobile) {
        this.showDropdown = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.header {
  color: white;
  padding: 1rem 0;
}

.container {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}

.logo {
  font-size: 1.8rem;
  font-weight: bold;
  letter-spacing: 1px;
  cursor: pointer;
  z-index: 10000;
  img {
    width: 200px;
  }
}

.hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
  z-index: 10000;
  padding: 10px;
  min-width: 44px;
  min-height: 44px;
  justify-content: center;
  align-items: center;

  span {
    display: block;
    width: 24px;
    height: 2px;
    background: white;
    transition: all 0.3s ease;
  }

  &.open {
    span:nth-child(1) {
      transform: rotate(45deg) translate(5px, 5px);
    }
    span:nth-child(2) {
      opacity: 0;
    }
    span:nth-child(3) {
      transform: rotate(-45deg) translate(5px, -5px);
    }
  }
}

.nav {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav a {
  color: white;
  text-decoration: none;
  font-size: 1rem;
  transition: all 0.3s;
  padding: 0.5rem 0;
  position: relative;

  &:hover {
    color: white;
  }

  &.active {
    color: white;

    &::after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 0;
      right: 0;
      height: 2px;
      background: white;
    }
  }
}

.nav-item {
  position: relative;

  .nav-link {
    display: block;
    color: white;
    font-size: 1rem;
    padding: 0.5rem 0;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;

    &.active {
      color: white;

      &::after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 0;
        right: 0;
        height: 2px;
        background: white;
      }
    }
  }

  &:hover .nav-link {
    color: white;
  }
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: transparent;
  padding: 0.5rem 0;
  z-index: 1000;
  white-space: nowrap;
  text-align: left;

  a {
    display: block;
    color: white;
    text-decoration: none;
    font-size: 0.95rem;
    transition: all 0.3s ease;
  }
}

.lang {
  margin-left: 1rem;
  padding-left: 1rem;
  cursor: pointer;

  &:hover {
    color: white;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
    flex-direction: row;
  }

  .logo img {
    width: 120px;
  }

  .hamburger {
    display: flex;
  }

  .nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(137, 3, 28, 0.95);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    z-index: 9999;
    transform: translateX(100%);
    transition: transform 0.3s ease;

    &.mobile-open {
      transform: translateX(0);
    }

    a {
      font-size: 1.2rem;
      padding: 0.8rem 0;
      min-height: 44px;
      display: flex;
      align-items: center;
    }
  }

  .nav-item {
    .nav-link {
      font-size: 1.2rem;
      padding: 0.8rem 0;
      min-height: 44px;
    }

    .dropdown-menu {
      position: relative;
      top: auto;
      left: auto;
      background: rgba(137, 3, 28, 0.95);
      transform: none;
      margin-top: 0.5rem;
      text-align: center;

      a {
        padding: 0.5rem 1rem;
        min-height: 44px;
      }
    }
  }

  .lang {
    margin-left: 0;
    border-left: none;
    padding-left: 0;
    min-height: 44px;
  }
}

@media (width > 1920px) {
  .container {
    max-width: 1680px;
  }
}
@media (width <= 1920px) {
  .container {
    max-width: 1400px;
  }
}
@media (width <= 1680px) {
  .container {
    max-width: 1400px;
  }
}
@media (width <= 1400px) {
  .container {
    max-width: 1200px;
  }
}
@media (width <= 1200px) {
  .container {
    width: 100%;
    padding: 0 20px;
  }
}
/* r14: consistent opening-screen inset. */
@media(min-width:769px){.container{box-sizing:border-box;padding-inline:34px}}
@media(min-width:769px) and (max-width:1200px){.container{padding-inline:54px}.nav{gap:1.25rem}}
@media(max-width:768px){.container{box-sizing:border-box;padding-inline:24px}}
</style>